import React from 'react';
import ConfiguracionBase from '../../components/configuracion/ConfiguracionBase';

const HELP = {
  tips: [
    'Estos estados describen en qué etapa está una reparación: "En proceso", "Esperando repuesto", "Terminada".',
    'A cada estado le podés asignar un color para identificarlo rápidamente en el portal mecánico.',
    'Definí estados que reflejen una demora real: así se ve claro dónde se traba el trabajo del taller.',
  ],
  nextSteps: [
    'El estado de reparación es indicado en las órdenes de trabajo correctivas.',
    'Ir actualizando el estado de cada reparación a medida que avanza.',
    'Revisar el informe de trabajos pendientes para detectar reparaciones demoradas.',
  ],
};

const ConfiguracionEstadosReparacion = () => {
  return (
    <ConfiguracionBase
      apiEndpoint="estados-reparacion"
      titulo="Estados de Reparación"
      descripcion="Estados internos de progreso de las órdenes de trabajo correctivas (ej: En proceso, Pendiente de repuestos)"
      icon="bi bi-tools"
      compact
      help={HELP}
    />
  );
};

export default ConfiguracionEstadosReparacion;
